export default [
    {
        value: 'linear',
        name: 'Linear',
        localizationSlug:'LINEAR'
    },
    {
        value: 'tiered-linear',
        name: 'Tiered Linear',
        localizationSlug: 'TIERED_LINEAR'
    },
    {
        value: 'tabular',
        name: 'Tabular',
        localizationSlug:'TABULAR'
    }
];